import Platform from '../base';
import unregisteredKeys from './config/keys/unregistered';
import navigationKeys from './config/keys/navigation';
import remoteKeys from './config/keys/remote-keys';
import tizenHelper from './helper';

class Tizen extends Platform {
  navigationKeys = navigationKeys;
  remoteKeys = remoteKeys;
  deviceInfo = {};

  initialize(opt) {
    super.initialize(opt);

    /* const debugDiv = document.createElement('div');
    debugDiv.id = 'debug';
    debugDiv.setAttribute(
      'style',
      'bottom:0; display: block; position: absolute; z-index: 99999; width: 1280px; min-height: 660px;\n' +
        'background-color: darkblue; padding: 10px 50px; font-size: 32px; color: white; opacity: 0.5; vertical-align: bottom',
    );

    document.body.appendChild(debugDiv);

    console.log = function() {
      var debug = document.getElementById('debug');
      Array.prototype.forEach.call(arguments, function(message) {
        if (typeof message === 'object') message = JSON.stringify(message);
        var newMsg = document.createElement('div');
        newMsg.innerHTML = message;
        debug.appendChild(newMsg);
        debug.scrollTop += 50;
      });
    };*/

    return new Promise((resolve) => {
      this.registerKeys();
      this.setUHDSupport();
      this.setHDRSupport();
      resolve();
    });
  }
  registerKeys() {
    const tvInputDevice = tizenHelper.getTizenTvInputDevice();

    try {
      unregisteredKeys.forEach((key) => tvInputDevice.registerKey(key));
    } catch (error) {
      console.error('failed to register : ' + error);
    }
  }

  _getDeviceId() {
    return window.webapis.productinfo.getDuid();
  }

  setUHDSupport() {
    try {
      this.deviceInfo.supportsUHD = !!window.webapis.productinfo.isUdPanelSupported();
    } catch (e) {
      this.deviceInfo.supportsUHD = false;
    }
  }

  setHDRSupport() {
    try {
      this.deviceInfo.supportsHDR = window.webapis.avinfo.isHdrTvSupport();
    } catch (error) {
      this.deviceInfo.supportsHDR = false;
    }
  }

  exit = () => {
    try {
      tizenHelper.getTizenCurrentApp().exit();
    } catch (error) {
      this._notifyError(error, 'Tizen SDK error in the exit');
    }
  };

  getFirmwareVersion() {
    try {
      return window.webapis.productinfo.getFirmware();
    } catch (e) {
      return Platform.prototype.getFirmwareVersion();
    }
  }

  getModelYear() {
    try {
      return parseInt('20' + window.webapis.productinfo.getModelCode().split('_')[0], 10);
    } catch (e) {
      return Platform.prototype.getModelYear();
    }
  }

  getModelName() {
    try {
      return window.webapis.productinfo.getRealModel();
      /* const tizenLibrary = tizenHelper.getTizenLibrary();
      return tizenLibrary.systeminfo.getCapability('http://tizen.org/system/model_name');*/
    } catch (e) {
      return Platform.prototype.getModelName();
    }
  }

  getUID() {
    try {
      this.deviceInfo.DUID = this.deviceInfo.DUID || window.webapis.productinfo.getDuid();
      return this.deviceInfo.DUID;
    } catch (e) {
      return Platform.prototype.getUID();
    }
  }

  getDeviceType() {
    return this.getModelYear() < 2017 ? 'OLD_TV' : 'SMART_TV';
  }

  getDeviceRegistrationType() {
    return 'Samsung Tizen';
  }

  getPlatformVersion() {
    try {
      return window.webapis.productinfo.getModelCode();
    } catch (e) {
      return Platform.prototype.getPlatformVersion();
    }
  }

  getConnectionType() {
    try {
      this.deviceInfo.connectionType = 'Unknown';
      const connectionTypeInt = window.webapis.network.getActiveConnectionType();

      switch (connectionTypeInt) {
        case 0:
          this.deviceInfo.connectionType = 'DISCONNECTED';
          break;
        case 1:
          this.deviceInfo.connectionType = 'Wi-Fi';
          break;
        case 2:
          this.deviceInfo.connectionType = 'Cellular';
          break;
        case 3:
          this.deviceInfo.connectionType = 'Ethernet';
          break;
        default:
          this.deviceInfo.connectionType = 'Unknown';
          break;
      }
    } catch (e) {
      return 'Unknown';
    }
  }

  getBrand() {
    return 'Samsung';
  }

  getName() {
    return 'Tizen';
  }

  getVASTAppPlatformName() {
    return 'sstv';
  }
}

export default Tizen;
